import type { FC, ReactNode } from "react"

interface SpecValueProps {
  label: string
  value: ReactNode
  "data-testid"?: string
}

export const SpecValue: FC<SpecValueProps> = ({ label, value, "data-testid": dataTestId }) => (
  <div className='flex flex-col gap-1'>
    <div className='text-xs text-gray-800'>{label}</div>
    <div className='text-sm font-medium text-gray-700' data-testid={dataTestId}>
      {value}
    </div>
  </div>
)
